import { render, staticRenderFns } from "./SiatRiepilogoPraticheModalComponent.vue?vue&type=template&id=58eb5372&scoped=true"
import script from "./SiatRiepilogoPraticheModalComponent.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheModalComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheModalComponent.vue?vue&type=style&index=0&id=58eb5372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb5372",
  null
  
)

export default component.exports